import {
  endDateChanged,
  pageChange,
  perPageChange,
  searchBarChanged,
  startDateChanged,
  stateBarChanged,
} from "./clientSideSearchActionCreators";
import Store from "../Store";
import { axiosInstance } from "../axios_Instanse";
import { axiosInstance_modal } from "../axios_instance_modal";

export const searchActiveOrders = (orderObject, searchInfo) => {
  //order array will be passed to this to make a live searchBar
  const { searchBar, stateValue, start_date, end_date } = searchInfo;
  return [...orderObject]
    ?.filter((order) =>
      order?.state ? order?.state?.includes(stateValue) : order
    )
    ?.filter(
      (order) =>
        order?.number?.includes(searchBar) || order?.state?.includes(searchBar)
    )
    ?.filter((order) => (order.cDate ? order?.cDate >= start_date : order))
    ?.filter((order) => (order.cDate ? order?.cDate <= end_date : order));
};

export const searchReadyToSendOrders = (orderObject, searchInfo) => {
  //order array will be passed to this to make a live searchBar

  const { searchBar, start_date, end_date } = searchInfo;
  return [...orderObject]
    ?.filter((order) =>
      order.number ? order?.number?.includes(searchBar) : order
    )
    ?.filter((order) => (order.cDate ? order?.cDate >= start_date : order))
    ?.filter((order) => (order.cDate ? order?.cDate <= end_date : order));
};
export const searchHistoryOrders = (orderObject, searchInfo) => {
  //order array will be passed to this to make a live searchBar

  const { searchBar } = searchInfo;
  return orderObject.filter((order) => order?.number?.includes(searchBar));
};
export const clearSearch = () => {
  Store.dispatch(endDateChanged(new Date().toJSON()));
  Store.dispatch(stateBarChanged(""));
  Store.dispatch(startDateChanged(""));
  Store.dispatch(searchBarChanged(""));
  Store.dispatch(pageChange(0));
  Store.dispatch(perPageChange(10));
};

export const toggle_activity = async (values) => {
  try {
    const { data } = await axiosInstance_modal.post(
      `/publisher/last_state`,
      values
    );

    return data;
  } catch (error) {}
};
export const toggle_online_offline = async (values) => {
  try {
    const { data } = await axiosInstance_modal.post(
      `/publisher/status`,
      values
    );

    return data;
  } catch (error) {}
};
export const get_publisher_state = async (values) => {
  try {
    const { data } = await axiosInstance.get(`/state`);
    localStorage.offline = data.offline;
    localStorage.last_state = data.last_state;
    return data;
  } catch (error) {}
};
export const utils = {
  today: (date) => {
    date = date ? date : new Date();
    let t = date
      .toLocaleDateString("fa-IR")
      .replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
    t = t.split("/");
    t = `${t[0]}/${t[1] < 10 ? "0" : ""}${t[1]}/${t[2] < 10 ? "0" : ""}${t[2]}`;
    return t;
  },
  get_time: (date) => {
    let st = date ? new Date(date) : new Date();
    return `${st.getHours() < 10 ? "0" : ""}${st.getHours()}:${
      st.getMinutes() < 10 ? "0" : ""
    }${st.getMinutes()}:${st.getSeconds() < 10 ? "0" : ""}${st.getSeconds()}`;
  },
  now: (nd) => {
    nd = nd ? new Date(nd) : new Date();
    let h = nd.getHours() - 3;
    let m = nd.getMinutes() - 30;
    return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}`;
  },
};

export const PagesUrl = () => {
  let menu;
  let pages = [];

  try {
    // eslint-disable-next-line
    menu = JSON.parse(localStorage.menu);
    menu.map((item) => {
      return item.menu_subs.map((i) => {
        let item = { title: i.title, value: i.link };
        return pages.push(item);
      });
    });
  } catch (error) {}

  return { pages };
};

export const Get_day = (date) => {
  return new Date(date).toLocaleDateString("fa-IR", { weekday: "long" });
};

export let now_time = (nd) => {
  let h = nd.getHours();
  let m = nd.getMinutes();
  return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}`;
};
export function getShamsiDate(dateString) {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();

  const gregorianEpoch = Date.UTC(1970, 0, 1);
  const gregorianDate = Date.UTC(year, month - 1, day);

  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const daysSinceEpoch = Math.floor(
    (gregorianDate - gregorianEpoch) / millisecondsPerDay
  );

  const shamsiEpoch = 2440588; // Shamsi epoch
  const shamsiDate = daysSinceEpoch + shamsiEpoch;

  const shamsiYear = Math.floor((shamsiDate - 1) / 365.25);
  const shamsiDayOfYear = Math.floor(shamsiDate - (shamsiYear * 365.25 + 0.75));
  const shamsiMonth = Math.floor((shamsiDayOfYear - 0.5) / 30) + 1;
  const shamsiDay = Math.floor((shamsiDayOfYear - 0.5) % 30) + 1;

  const daysOfWeek = [
    "شنبه",
    "یک شنبه",
    "دو شنبه",
    "سه شنبه",
    "چهار شنبه",
    "پنج شنبه",
    "جمعه",
  ];
  const monthsOfYear = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const dayOfWeek = daysOfWeek[date.getUTCDay()];
  const formattedDate =
    dayOfWeek + " " + shamsiDay + " " + monthsOfYear[shamsiMonth - 1];

  return formattedDate;
}

export function convertGregorianToShamsi(gregorianDateString) {
  const gregorianDate = new Date(gregorianDateString);
  const gregorianYear = gregorianDate.getFullYear();
  const gregorianMonth = gregorianDate.getMonth() + 1;
  const gregorianDay = gregorianDate.getDate();

  // Calculate the number of days passed since the beginning of the Gregorian year
  let gregorianDaysPassed = 0;
  const gregorianMonthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  for (let i = 0; i < gregorianMonth - 1; i++) {
    gregorianDaysPassed += gregorianMonthDays[i];
  }
  gregorianDaysPassed += gregorianDay;

  // Adjust the Gregorian year and month if it's a leap year
  if (
    (gregorianYear % 4 === 0 && gregorianYear % 100 !== 0) ||
    gregorianYear % 400 === 0
  ) {
    gregorianDaysPassed++;
  }

  // Convert the Gregorian year, month, and day to the Shamsi equivalent using a predefined table
  const shamsiYear = gregorianYear - 621;
  const shamsiMonthDays = [
    31,
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    (gregorianYear % 4 === 0 && gregorianYear % 100 !== 0) ||
    gregorianYear % 400 === 0
      ? 30
      : 29,
  ];

  let shamsiMonth = 0;
  let shamsiDay = gregorianDaysPassed;

  for (let i = 0; i < shamsiMonthDays.length; i++) {
    shamsiDay -= shamsiMonthDays[i];
    if (shamsiDay > 0) {
      shamsiMonth++;
    } else {
      shamsiDay += shamsiMonthDays[i];
      break;
    }
  }

  // Create a valid Shamsi date string
  const shamsiDateString = `${shamsiYear}/${String(shamsiMonth + 1).padStart(
    2,
    "0"
  )}/${String(shamsiDay).padStart(2, "0")}`;
  return shamsiDateString;
}

export function compareShamsiDates(date1, date2) {
  const [year1, month1, day1] = date1.split("/").map(Number);
  const [year2, month2, day2] = date2.split("/").map(Number);

  if (year1 > year2) {
    return 1;
  } else if (year1 < year2) {
    return -1;
  } else {
    if (month1 > month2) {
      return 1;
    } else if (month1 < month2) {
      return -1;
    } else {
      if (day1 > day2) {
        return 1;
      } else if (day1 < day2) {
        return -1;
      } else {
        return 0;
      }
    }
  }
}
export function convertShamsiToDate(shamsiDate) {
  const [shamsiYear, shamsiMonth, shamsiDay] = shamsiDate
    .split("/")
    .map(Number);

  // Adjust the Shamsi year to the Gregorian year
  const gregorianYear = shamsiYear + 621;

  // Create a valid JavaScript Date object with time set to 00:00 (midnight)
  const date = new Date(gregorianYear, shamsiMonth - 1, shamsiDay, 0, 0, 0);
  date.setUTCHours(0, 0, 0, 0); // Set the UTC hours to ensure correct time representation

  return date.toISOString();
}
